export function DevUser({
    uid,
    name,
    email,
    debugOnly,
} = {}) {
    return {
        uid,
        name,
        email,
        debugOnly,
    };
}